module.exports = __webpack_public_path__ + "img/rent.fabe1cb8.svg";